import React, { useEffect, useContext } from 'react';
import SummaryPlan from '../../common/Summary/SummaryPlan';
import { PageAbsolutePath } from '../../../consts/Common';
import Confirm from '../../common/Confirmation/Confirm';
import { SiteContext } from '../../../context/SiteContext';
import PageHeader from '../../common/PageHeader';
import { useJourney } from '../Layout';
import { BoughtProductsDto, QuoteApiResponse } from '../../common/CommonTypes';
import { QuotesApi } from '../../../api/QuotesApi';
import { getSelectedProducts } from '../../common/ProductMethods';
import { useTranslation } from 'react-i18next';
import ConfirmationExtraDetails from '../../common/Confirmation/ConfirmationExtraDetails';

const CustomerConfirmationPage = (): JSX.Element => {
  const { journey, onPageChange } = useJourney();
  const { products, personalDetail, orderNumbers, quoteId, token, dealerCode } =
    journey;
  const { site } = useContext(SiteContext);

  //Keeping this as Dealer content for now, will need updating once the customer journey has been set up in the CMS
  const cms = site.content.confirmationPage;

  const { t } = useTranslation();
  const isCallCentreUser = !!site.user?.userId;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    onPageChange(PageAbsolutePath.Customer.Confirmation, true);
    updateQuotes();
  }, []);

  const updateQuotes = () => {
    if (site.includeQuotes && quoteId > 0) {
      const controller = new AbortController();

      const successCallback = (data: QuoteApiResponse) => {
        if (data.isSaved) {
          console.log('Quote saved');
        }
      };

      const failureCallback = () => {
        console.log('Error occured in quote api save...');
      };

      const selectedProducts = getSelectedProducts(products);

      const quotesBought: BoughtProductsDto = {
        bought: true,
        dealerNumber: dealerCode,
        quoteId: quoteId,
        productTypeId: selectedProducts.map((x) => x.productTypeId)
      };

      new QuotesApi().saveQuoteBought(
        quotesBought,
        token,
        successCallback,
        failureCallback,
        controller.signal
      );

      return () => {
        controller.abort();
      };
    }
  };

  const emailConfirmationText = cms.emailConfirmation
    ? cms.emailConfirmation.replace('{EMAILADDRESS}', personalDetail.email)
    : '';

  const referenceText = t('confirmation.your-reference', {
    orderNumbervalues: orderNumbers.join(' & '),
    interpolation: { escapeValue: false }
  });

  return (
    <>
      <PageHeader
        title={cms.title}
        description={cms.description}
        information={cms.information}
        warning={cms.warning}
        descriptionClass='p2'
      />
      <Confirm
        subTitle={cms.summaryDescription}
        emailConfirmationText={emailConfirmationText}
        orderNumbers={orderNumbers}
        referenceText={referenceText}>
        <div className='product-selection-card-container m2-bottom'>
          <SummaryPlan
            products={products}
            showRemove={false}
            showTitle={false}
            showEdit={false}
            culture={site.cultureCode}
          />
        </div>
        {isCallCentreUser === true && (
          <ConfirmationExtraDetails referenceText={referenceText} />
        )}
      </Confirm>
    </>
  );
};

export default CustomerConfirmationPage;
